"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocClause = exports.Seniority = exports.CDSConvention = exports.Outputs = exports.StubRule = exports.PaymentFrequency = exports.Direction = exports.DayCountBasisConvention = exports.BusinessDayConvention = void 0;
var financial_contracts_1 = require("./financial-contracts");
Object.defineProperty(exports, "BusinessDayConvention", { enumerable: true, get: function () { return financial_contracts_1.BusinessDayConvention; } });
Object.defineProperty(exports, "DayCountBasisConvention", { enumerable: true, get: function () { return financial_contracts_1.DayCountBasisConvention; } });
Object.defineProperty(exports, "Direction", { enumerable: true, get: function () { return financial_contracts_1.Direction; } });
Object.defineProperty(exports, "PaymentFrequency", { enumerable: true, get: function () { return financial_contracts_1.PaymentFrequency; } });
Object.defineProperty(exports, "StubRule", { enumerable: true, get: function () { return financial_contracts_1.StubRule; } });
Object.defineProperty(exports, "Outputs", { enumerable: true, get: function () { return financial_contracts_1.Outputs; } });
var CDSConvention;
(function (CDSConvention) {
    CDSConvention["ISDA"] = "ISDA";
    CDSConvention["UserDefined"] = "User-defined";
})(CDSConvention || (exports.CDSConvention = CDSConvention = {}));
var Seniority;
(function (Seniority) {
    Seniority["Secured"] = "Secured";
    Seniority["SeniorUnsecured"] = "SeniorUnsecured";
    Seniority["Subordinated"] = "Subordinated";
    Seniority["JuniorSubordinated"] = "JuniorSubordinated";
    Seniority["Preference"] = "Preference";
    Seniority["None"] = "None";
})(Seniority || (exports.Seniority = Seniority = {}));
var DocClause;
(function (DocClause) {
    DocClause["CumRestruct14"] = "CumRestruct14";
    DocClause["ModifiedRestruct14"] = "ModifiedRestruct14";
    DocClause["ModModRestruct14"] = "ModModRestruct14";
    DocClause["ExRestruct14"] = "ExRestruct14";
    DocClause["CumRestruct03"] = "CumRestruct03";
    DocClause["ModifiedRestruct03"] = "ModifiedRestruct03";
    DocClause["ModModRestruct03"] = "ModModRestruct03";
    DocClause["ExRestruct03"] = "ExRestruct03";
    DocClause["None"] = "None";
})(DocClause || (exports.DocClause = DocClause = {}));
